




















































































































































































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import TitleMixin from '@/mixins/title-mixin';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import AdminChart from '@/components/charts/admin-chart.vue';
import { GatewaysApi, Site } from '@/api';
import AddUpdateEntityLocation from '@/components/add business objects/addUpdateEntityLocation.vue';
import StatusRow from '@/components/display/information-rows/status-row.vue';
import InlineEditor from '@/components/display/inline-editor.vue';
import SitePicker from '@/components/site-picker.vue';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: {
		SitePicker,
		InlineEditor,
		StatusRow,
		AddUpdateEntityLocation,
		RouterLinkButton,
		secondaryNav,
		infoTabs,
		AdminChart,
	},
	mixins: [TitleMixin],
})
export default class GatewaysView extends Vue {
	public smallScreen = window.innerWidth > 1000;
	public loading = false;
	public $bvToast: any;
	public gateway: any | null = null;
	public site: any | null = null;
	public next = '';
	public prev = '';
	public rawData: any[] | null = [];
	public audits: any[] | null = null;
	public parentLocations = [];
	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	private api: GatewaysApi = new GatewaysApi();
	private toast = new Toast();

	private newSite?: Site | null = this.gateway?.site ?? null;

	public pageTitle() {
		return `gateway | ${this.gateway ? this.gateway.serialNumber : ''}`;
	}

	public async load() {
		const { gatewayId } = this.$route.params;
		this.loading = true;
		try {
			const { data } = await this.api.getGatewayById(parseInt(gatewayId, 10), {
				params: {
					include: 'site,audits,entitylocation,nodes.entitylocation,transceiver.entitylocation',
				},
			});
			this.gateway = data ?? {};
			this.audits = this.gateway.audits ?? [];
			this.newSite = this.gateway.site ?? null;
			this.parentLocations = [];
			if (this.gateway.transceiver && this.gateway.transceiver.entitylocation) {
				this.parentLocations.push({
					type: 'Transceiver',
					latitude: this.gateway.transceiver.entitylocation.latitude,
					longitude: this.gateway.transceiver.entitylocation.longitude,
				});
			}
			if (this.gateway.site && this.gateway.site.latitude) {
				this.parentLocations.push({
					type: 'Site',
					latitude: this.gateway.site.latitude,
					longitude: this.gateway.site.longitude,
				});
			}
			if (this.gateway.entitylocation == null) {
				this.gateway.entitylocation = {
					id: null,
					entityId: this.gateway.id,
					entityType: 'gateways',
					latitude: null,
					longitude: null,
					notes: null,
				};
			}
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(e, 'Error loading gateway');
			this.toast.makeToast(errorMessage, 'Error', 'danger');
			this.gateway = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}

	private updateSite(callback: (hasError: boolean) => void) {
		if (this.newSite === this.gateway.site) {
			callback(false);
			return;
		}
		try {
			this.api.updateGateway(this.gateway.id!, {
				data: {
					...this.gateway,
					siteId: this.newSite?.id ?? null,
				},
			});
			this.gateway.siteId = this.newSite?.id ?? null;
			this.gateway.site = this.newSite;
			this.toast.makeToast('Updated gateway site', 'Success Updating Gateway Site', 'success');
			callback(false);
		} catch (ex) {
			const { errorMessage } = ApiUtils.handleApiError(ex, 'Error updating gateway site');
			this.toast.makeToast(errorMessage, 'Error Updating Gateway Site', 'danger');
			callback(true);
		}
	}
}
